module.exports = __webpack_public_path__ + "static/media/header-wordmark.15322659.svg";